import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { LayoutGrid } from "lucide-react";

import api from "../../../const/axios";
import { withRouter } from "../../../utils/withRouter";
import { loadingOff, loadingOn, setPackages } from "../../../redux/actions";
import Package from "../../Elements/Package/Package";

interface TournamentPackagesProps {
  params: { id: string };
  loadingOn: () => void;
  loadingOff: () => void;
  setPackages: (packages: any[]) => void;
}

const TournamentPackages: React.FC<TournamentPackagesProps> = ({
  params,
  loadingOn,
  loadingOff,
  setPackages,
}) => {
  const [topText, setTopText] = useState("");
  const [single, setSingle] = useState(false);
  const [tournaments, setTournaments] = useState<any[]>([]);
  const [packages, setPackagesList] = useState<any[]>([]);

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      loadingOn();
      try {
        const res = await api.get(`packages/forcont?id=${params.id}`);
        if (cancelled) return;

        if (res.data.continuation) {
          let packs: any[] = [];
          res.data.tournaments.forEach((element: any) => {
            element.packages.forEach((el: any) => {
              packs.push(el);
            });
          });

          setTopText(res.data.continuation.name);
          if (res.data.continuation.isLeague) {
            setSingle(false);
            setTournaments(res.data.tournaments);
          } else {
            setSingle(true);
            setPackagesList(packs);
          }
          setPackages(packs);
        } else if (res.data.tournaments && res.data.tournaments.length > 0) {
          const tournament = res.data.tournaments[0];
          setTopText(tournament.name);
          setSingle(true);
          setPackagesList(tournament.packages);
          setPackages(tournament.packages);
        }
      } catch (error) {
        console.error("Error fetching tournament packages:", error);
      } finally {
        if (!cancelled) loadingOff();
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, [params.id, loadingOn, loadingOff, setPackages]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pt-16">
      <Helmet>
        <title>{topText ? `${topText} | 3sual.az` : "Paketlər | 3sual.az"}</title>
        <meta name="robots" content="index" />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
        {/* Header section */}
        <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 px-6 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white">
              <LayoutGrid className="w-5 h-5" />
            </div>
            <h1 className="text-xl sm:text-2xl font-black text-gray-900 dark:text-gray-50 leading-tight">
              {topText || "Yüklənir..."}
            </h1>
          </div>
        </div>

        {/* Content section */}
        <div className="space-y-8">
          {single ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {packages.map((item, index) => (
                <Link key={index} to={`/packages/${item.id}`} className="block">
                  <Package pack={item} free={true} />
                </Link>
              ))}
            </div>
          ) : (
            tournaments.map((t, index) => (
              <div key={index} className="space-y-4">
                {t.packages.length > 0 && (
                  <div className="flex items-center gap-2">
                    <div className="h-8 w-1 bg-blue-600 rounded-full" />
                    <h3 className="text-lg font-bold text-gray-800 dark:text-gray-100">{t.name}</h3>
                  </div>
                )}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {t.packages.map((item: any, ind: number) => (
                    <Link key={ind} to={`/packages/${item.id}`} className="block">
                      <Package pack={item} free={true} />
                    </Link>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(
  connect(null, { loadingOn, loadingOff, setPackages })(TournamentPackages)
);

